<template>
    <div>
        <div class="top-nav" v-if="!editMode">
            <div class="operation">
                <div @click="gridViewToggle">
                    <span class="icon" v-if="gridView">
                        <svg
                            width="46px"
                            height="22px"
                            viewBox="0 0 46 22"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                            <!-- Generator: Sketch 53 (72520) - https://sketchapp.com -->
                            <!-- <title>Group</title> -->
                            <desc>Created with Sketch.</desc>
                            <g
                                id="Symbols"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                            >
                                <g
                                    id="header/VIEW/glance"
                                    transform="translate(1.000000, 1.000000)"
                                >
                                    <g id="Group">
                                        <path
                                            d="M22,0 L42,0 C43.1045695,-2.02906125e-16 44,0.8954305 44,2 L44,18 C44,19.1045695 43.1045695,20 42,20 L22,20 L22,0 Z"
                                            id="Rectangle"
                                            stroke="#DEE1E7"
                                            fill="#FEFEFE"
                                        />
                                        <path
                                            d="M2,0 L22,0 L22,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
                                            id="Rectangle-Copy-4"
                                            stroke="#156EC9"
                                            fill="#156EC9"
                                        />
                                        <path
                                            d="M5.70588235,4.70588235 L5.70588235,6.82352941 L7.82352941,6.82352941 L7.82352941,4.70588235 L5.70588235,4.70588235 Z M5,4 L8.52941176,4 L8.52941176,7.52941176 L5,7.52941176 L5,4 Z M9.94117647,4.70588235 L9.94117647,6.82352941 L12.0588235,6.82352941 L12.0588235,4.70588235 L9.94117647,4.70588235 Z M9.23529412,4 L12.7647059,4 L12.7647059,7.52941176 L9.23529412,7.52941176 L9.23529412,4 Z M5.70588235,8.94117647 L5.70588235,11.0588235 L7.82352941,11.0588235 L7.82352941,8.94117647 L5.70588235,8.94117647 Z M5,8.23529412 L8.52941176,8.23529412 L8.52941176,11.7647059 L5,11.7647059 L5,8.23529412 Z M9.94117647,8.94117647 L9.94117647,11.0588235 L12.0588235,11.0588235 L12.0588235,8.94117647 L9.94117647,8.94117647 Z M9.23529412,8.23529412 L12.7647059,8.23529412 L12.7647059,11.7647059 L9.23529412,11.7647059 L9.23529412,8.23529412 Z M5.70588235,13.1764706 L5.70588235,15.2941176 L7.82352941,15.2941176 L7.82352941,13.1764706 L5.70588235,13.1764706 Z M5,12.4705882 L8.52941176,12.4705882 L8.52941176,16 L5,16 L5,12.4705882 Z M9.94117647,13.1764706 L9.94117647,15.2941176 L12.0588235,15.2941176 L12.0588235,13.1764706 L9.94117647,13.1764706 Z M9.23529412,12.4705882 L12.7647059,12.4705882 L12.7647059,16 L9.23529412,16 L9.23529412,12.4705882 Z M14.1764706,4.70588235 L14.1764706,6.82352941 L16.2941176,6.82352941 L16.2941176,4.70588235 L14.1764706,4.70588235 Z M13.4705882,4 L17,4 L17,7.52941176 L13.4705882,7.52941176 L13.4705882,4 Z M14.1764706,8.94117647 L14.1764706,11.0588235 L16.2941176,11.0588235 L16.2941176,8.94117647 L14.1764706,8.94117647 Z M13.4705882,8.23529412 L17,8.23529412 L17,11.7647059 L13.4705882,11.7647059 L13.4705882,8.23529412 Z M14.1764706,13.1764706 L14.1764706,15.2941176 L16.2941176,15.2941176 L16.2941176,13.1764706 L14.1764706,13.1764706 Z M13.4705882,12.4705882 L17,12.4705882 L17,16 L13.4705882,16 L13.4705882,12.4705882 Z"
                                            id="Shape"
                                            fill="#F3F3F3"
                                            fill-rule="nonzero"
                                        />
                                        <path
                                            d="M27.3529412,5.66176471 C27.1580171,5.66176471 27,5.51362363 27,5.33088235 C27,5.14814108 27.1580171,5 27.3529412,5 L38.6470588,5 C38.8419829,5 39,5.14814108 39,5.33088235 C39,5.51362363 38.8419829,5.66176471 38.6470588,5.66176471 L27.3529412,5.66176471 Z M27.3529412,8.97058824 C27.1580171,8.97058824 27,8.82244716 27,8.63970588 C27,8.4569646 27.1580171,8.30882353 27.3529412,8.30882353 L38.6470588,8.30882353 C38.8419829,8.30882353 39,8.4569646 39,8.63970588 C39,8.82244716 38.8419829,8.97058824 38.6470588,8.97058824 L27.3529412,8.97058824 Z M27.3529412,12.2794118 C27.1580171,12.2794118 27,12.1312707 27,11.9485294 C27,11.7657881 27.1580171,11.6176471 27.3529412,11.6176471 L38.6470588,11.6176471 C38.8419829,11.6176471 39,11.7657881 39,11.9485294 C39,12.1312707 38.8419829,12.2794118 38.6470588,12.2794118 L27.3529412,12.2794118 Z M27.3529412,15.5882353 C27.1580171,15.5882353 27,15.4400942 27,15.2573529 C27,15.0746117 27.1580171,14.9264706 27.3529412,14.9264706 L38.6470588,14.9264706 C38.8419829,14.9264706 39,15.0746117 39,15.2573529 C39,15.4400942 38.8419829,15.5882353 38.6470588,15.5882353 L27.3529412,15.5882353 Z"
                                            id="Shape"
                                            fill="#DEE1E7"
                                            fill-rule="nonzero"
                                        />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </span>
                    <span class="icon" v-else>
                        <svg
                            width="46px"
                            height="22px"
                            viewBox="0 0 46 22"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                            <!-- Generator: Sketch 53 (72520) - https://sketchapp.com -->
                            <!-- <title>Group</title> -->
                            <desc>Created with Sketch.</desc>
                            <g
                                id="Symbols"
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                            >
                                <g
                                    id="header/VIEW/details"
                                    transform="translate(1.000000, 1.000000)"
                                >
                                    <g id="Group">
                                        <path
                                            d="M22,0 L42,0 C43.1045695,-2.02906125e-16 44,0.8954305 44,2 L44,18 C44,19.1045695 43.1045695,20 42,20 L22,20 L22,0 Z"
                                            id="Rectangle"
                                            stroke="#156EC9"
                                            fill="#156EC9"
                                        />
                                        <path
                                            d="M2,0 L22,0 L22,20 L2,20 C0.8954305,20 1.3527075e-16,19.1045695 0,18 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z"
                                            id="Rectangle-Copy-4"
                                            stroke="#DEE1E7"
                                            fill="#FEFEFE"
                                        />
                                        <path
                                            d="M5.70588235,4.70588235 L5.70588235,6.82352941 L7.82352941,6.82352941 L7.82352941,4.70588235 L5.70588235,4.70588235 Z M5,4 L8.52941176,4 L8.52941176,7.52941176 L5,7.52941176 L5,4 Z M9.94117647,4.70588235 L9.94117647,6.82352941 L12.0588235,6.82352941 L12.0588235,4.70588235 L9.94117647,4.70588235 Z M9.23529412,4 L12.7647059,4 L12.7647059,7.52941176 L9.23529412,7.52941176 L9.23529412,4 Z M5.70588235,8.94117647 L5.70588235,11.0588235 L7.82352941,11.0588235 L7.82352941,8.94117647 L5.70588235,8.94117647 Z M5,8.23529412 L8.52941176,8.23529412 L8.52941176,11.7647059 L5,11.7647059 L5,8.23529412 Z M9.94117647,8.94117647 L9.94117647,11.0588235 L12.0588235,11.0588235 L12.0588235,8.94117647 L9.94117647,8.94117647 Z M9.23529412,8.23529412 L12.7647059,8.23529412 L12.7647059,11.7647059 L9.23529412,11.7647059 L9.23529412,8.23529412 Z M5.70588235,13.1764706 L5.70588235,15.2941176 L7.82352941,15.2941176 L7.82352941,13.1764706 L5.70588235,13.1764706 Z M5,12.4705882 L8.52941176,12.4705882 L8.52941176,16 L5,16 L5,12.4705882 Z M9.94117647,13.1764706 L9.94117647,15.2941176 L12.0588235,15.2941176 L12.0588235,13.1764706 L9.94117647,13.1764706 Z M9.23529412,12.4705882 L12.7647059,12.4705882 L12.7647059,16 L9.23529412,16 L9.23529412,12.4705882 Z M14.1764706,4.70588235 L14.1764706,6.82352941 L16.2941176,6.82352941 L16.2941176,4.70588235 L14.1764706,4.70588235 Z M13.4705882,4 L17,4 L17,7.52941176 L13.4705882,7.52941176 L13.4705882,4 Z M14.1764706,8.94117647 L14.1764706,11.0588235 L16.2941176,11.0588235 L16.2941176,8.94117647 L14.1764706,8.94117647 Z M13.4705882,8.23529412 L17,8.23529412 L17,11.7647059 L13.4705882,11.7647059 L13.4705882,8.23529412 Z M14.1764706,13.1764706 L14.1764706,15.2941176 L16.2941176,15.2941176 L16.2941176,13.1764706 L14.1764706,13.1764706 Z M13.4705882,12.4705882 L17,12.4705882 L17,16 L13.4705882,16 L13.4705882,12.4705882 Z"
                                            id="Shape"
                                            fill="#DEE1E7"
                                            fill-rule="nonzero"
                                        />
                                        <path
                                            d="M27.3529412,5.66176471 C27.1580171,5.66176471 27,5.51362363 27,5.33088235 C27,5.14814108 27.1580171,5 27.3529412,5 L38.6470588,5 C38.8419829,5 39,5.14814108 39,5.33088235 C39,5.51362363 38.8419829,5.66176471 38.6470588,5.66176471 L27.3529412,5.66176471 Z M27.3529412,8.97058824 C27.1580171,8.97058824 27,8.82244716 27,8.63970588 C27,8.4569646 27.1580171,8.30882353 27.3529412,8.30882353 L38.6470588,8.30882353 C38.8419829,8.30882353 39,8.4569646 39,8.63970588 C39,8.82244716 38.8419829,8.97058824 38.6470588,8.97058824 L27.3529412,8.97058824 Z M27.3529412,12.2794118 C27.1580171,12.2794118 27,12.1312707 27,11.9485294 C27,11.7657881 27.1580171,11.6176471 27.3529412,11.6176471 L38.6470588,11.6176471 C38.8419829,11.6176471 39,11.7657881 39,11.9485294 C39,12.1312707 38.8419829,12.2794118 38.6470588,12.2794118 L27.3529412,12.2794118 Z M27.3529412,15.5882353 C27.1580171,15.5882353 27,15.4400942 27,15.2573529 C27,15.0746117 27.1580171,14.9264706 27.3529412,14.9264706 L38.6470588,14.9264706 C38.8419829,14.9264706 39,15.0746117 39,15.2573529 C39,15.4400942 38.8419829,15.5882353 38.6470588,15.5882353 L27.3529412,15.5882353 Z"
                                            id="Shape"
                                            fill="#F3F3F3"
                                            fill-rule="nonzero"
                                        />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </span>
                    <span class="desc">{{ $t("edit.view") }}</span>
                </div>
                <div class="refresh" @click="refresh">
                    <span class="icon" :class="{spining:refreshing}">&#xe977;</span>
                    <span class="desc">{{ $t("edit.refresh") }}</span>
                </div>
                <div class="select" @click="editModeToggle">
                    <span class="icon">&#xe9aa;</span>
                    <span class="desc">{{ $t("edit.select") }}</span>
                </div>
            </div>
            <div class="search" :class="{ active: focus }">
                <span class="icon">&#xe900;</span>
                <input type="text" @focus="searchFocus" @blur="searchBlur" v-model="keyWord" />
            </div>
        </div>
        <div class="edit-panel" v-else>
            <div class="cancel" @click="cancel">{{$t('edit.cancel')}}</div>
            <div class="select-num">{{ `${selectNum} ${$t('edit.selected')}`}}</div>
            <div class="delete" @click="deleteSelect">
                <span class="icon">&#xe926;</span>
                <span>{{$t('edit.delete')}}</span>
            </div>
            <div class="download" v-if="false">
                <span class="icon">&#xe90d;</span>
                <span>{{$t('edit.download')}}</span>
            </div>
            <div class="moveto" :class="{disable:ifCouldMove}" @click.stop="showCloset">
                <span class="icon">&#xe92d;</span>
                <span>{{$t('edit.moveto')}}</span>
                <span class="arrow icon">&#xe91c;</span>
                <ul class="child-list" v-if="ifShowCloset">
                    <li>
                        <a @click.stop="moveToCase(-1)">{{$t('action.create-newcase')}}</a>
                    </li>
                    <div class="case-list">
                        <li
                            v-for="(c,index) in caseList"
                            :class="{disabled:index==caseNowIn}"
                            :key="index"
                            @click.stop="moveToCase(index)"
                        >
                            <a>{{c}}</a>
                        </li>
                    </div>
                </ul>
            </div>
            <div class="moveout" v-if="inCase" @click="moveOut">
                <span class="icon">&#xe9ab;</span>
                <span>{{$t('edit.moveout')}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            focus: false,
            ifShowCloset: false
        };
    },
    props: {
        refreshing: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState([
            "editMode",
            "gridView",
            "allCases",
            "beSelected",
            "requestPending"
        ]),
        ...mapGetters(["selectNum"]),
        keyWord: {
            get() {
                return this.$store.state.keyWord;
            },
            set(v) {
                this.$store.commit("searchByKeyword", v);
            }
        },
        inCase() {
            let params = this.$route.params;
            return params.caseName && params.caseName !== "tag";
        },
        caseList() {
            return this.allCases.map(v => {
                return v.caseName;
            });
        },
        /**
         * disable the 'Move to case' when select case
         */
        ifCouldMove() {
            return this.beSelected.some(v => {
                return v.slice(0, 1) == "c";
            });
        },
        caseNowIn() {
            let caseName = this.$route.params.caseName;
            let index = -1;
            for (let i in this.allCases) {
                if (this.allCases[i].caseName == caseName) {
                    index = i;
                }
            }
            return index;
        }
    },
    methods: {
        ...mapMutations([
            "editModeToggle",
            "clearSelect",
            "gridViewToggle",
            "searchByKeyword"
        ]),
        ...mapActions([
            "delete",
            "itemMoveOut",
            "moveItem",
            "moveToNewCase",
            "moveItemToNewCase",
            "getWorkSpace"
        ]),
        /**
         * quit edit mode
         */
        cancel() {
            this.editModeToggle();
            this.clearSelect();
        },
        showCloset() {
            if (this.beSelected.length == 0 || this.ifCouldMove) {
                return;
            }
            this.ifShowCloset = true;
            document.addEventListener("click", this.hideCloset);
        },
        hideCloset() {
            this.ifShowCloset = false;
            document.removeEventListener("click", this.hideCloset);
        },
        /**
         * @param {Number} index -index of the target case
         */
        moveToCase(index) {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            this.hideCloset();
            this.editModeToggle();
            if (index == -1) {
                this.moveToNewCase();
            } else {
                let payload = {};
                let target_case = this.allCases[index]["o_id"];
                payload["target_case"] = target_case;
                this.moveItem(payload)
                    .then(() => {
                        this.$toast();
                    })
                    .catch(() => {
                        this.$toast({ status: 1, forceFadeOut: true });
                    });
                this.$toast({ status: 2 });
            }
        },
        moveToNewCase() {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            this.$dialog({ type: "dialog" });
            this.$fire.$on("caseName", (data, timestamp) => {
                if (data) {
                    this.moveItemToNewCase({ name: data, timestamp: timestamp })
                        .then(() => {
                            this.$toast();
                        })
                        .catch(() => {
                            this.$toast({ status: 1, forceFadeOut: true });
                        });
                    this.$toast({ status: 2 });
                }
                this.$fire.$off("caseName");
            });
        },
        refresh() {
            this.$emit("refresh");
        },
        searchFocus() {
            this.focus = true;
        },
        searchBlur() {
            this.focus = false;
        },
        deleteSelect() {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            if (this.beSelected.length == 0) {
                return;
            }
            this.$dialog({ type: "confirm" });
            this.$fire.$on("confirm", confirm => {
                if (confirm) {
                    this.delete()
                        .then(() => {
                            this.$toast();
                        })
                        .catch(() => {
                            this.$toast({ status: 1, forceFadeOut: true });
                        });
                    this.$toast({ status: 2 });
                    this.editModeToggle();
                }
                this.$fire.$off("confirm");
            });
        },
        moveOut() {
            if (this.requestPending) {
                this.$toast({ status: 3, forceFadeOut: true });
                return;
            }
            this.editModeToggle();
            this.itemMoveOut()
                .then(() => {
                    this.$toast();
                })
                .catch(() => {
                    this.$toast({ status: 1, forceFadeOut: true });
                });
            this.$toast({ status: 2 });
        }
    },
    watch: {
        keyWord: function(val) {
            this.$emit("search", val);
        }
    }
};
</script>

<style lang="scss" scoped>
.top-nav {
    @include flex;
    align-self: stretch;
    justify-content: space-between;
    height: 40px;
    .operation {
        @include flex;
        flex-direction: row;
        svg.view-change {
            position: absolute;
            left: 50%;
            top: -10px;
            transform: translateX(-50%);
        }
        & > div {
            @include flex;
            flex-direction: column;
            margin: 0 15px;
            padding-bottom: 2px;
            color: $light-purple;
            justify-content: space-between;
            font-size: $font-base-size - 4px;
            width: 66px;
            height: 50px;
            border-radius: 4px;
            cursor: pointer;
            &.refresh .icon,
            &.select .icon {
                font-size: $font-base-size + 6px;
                transform-origin: 50%;
            }
            &:hover {
                background-color: $border-color;
            }
            span:first-child {
                cursor: pointer;
                flex-grow: 1;
                margin-top: 5px;
                margin-bottom: 4px;
                position: relative;
            }
        }
    }
    .search {
        background-color: #fefefe;
        width: 310px;
        height: 40px;
        padding: 5px 20px;
        border: 1px solid transparent;
        box-shadow: 0px 1px 16px -6px rgba(13, 36, 60, 0.5);
        border-radius: 4px;
        position: relative;
        transition: box-shadow 300ms;

        .icon {
            position: absolute;
            font-size: $font-base-size + 2px;
            color: #b3bdc8;
            right: 16px;
            top: 20px;
            transform: translateY(-50%);
        }
        input {
            padding-right: 20px;
            border: none;
            line-height: 30px;
            width: 270px;
            outline: none;
        }
        &:hover {
            box-shadow: none;
        }
        &.active {
            border-color: $light-purple;
            box-shadow: none;
            .icon {
                color: $light-purple;
            }
        }
    }
}
.edit-panel {
    @include flex;
    justify-content: flex-start;
    & > div {
        flex-shrink: 0;
        margin: 0 15px;
    }
    .cancel {
        @include flex;

        color: $light-purple;
        font-size: $font-base-size;
        width: 128px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid $border-color;
        cursor: pointer;
        &:hover {
            border-color: $light-purple;
        }
        &:active {
            background-color: $light-purple;
            border-color: $light-purple;
            color: $base-color;
        }
    }
    .select-num {
        flex-basis: 90px;
        font-size: 16px;
        color: $dark-purple;
    }
    .delete,
    .download,
    .moveout,
    .moveto {
        @include flex;
        font-size: 16px;
        color: $font-base-color;
        width: 140px;
        height: 30px;
        border-radius: 4px;
        border: 1px solid $border-purple;
        cursor: pointer;
        & > .icon {
            margin-right: 10px;
        }
    }
    .delete {
        &:hover {
            border-color: $delete;
            color: $delete;
            & > .icon {
                color: $delete;
            }
        }
        &:active {
            background-color: $delete;
            color: $base-color;
            border-color: $delete;
            & > .icon {
                color: $base-color;
            }
        }
    }
    .download,
    .moveout,
    .moveto {
        &:hover {
            border-color: $dark-purple;
        }
        &:active {
            background-color: $light-purple;
            border-color: $light-purple;
            color: $base-color;
            & > .icon {
                color: $base-color;
            }
        }
    }
    .moveto {
        position: relative;
        & > .arrow {
            margin-right: 0;
            margin-left: 10px;
            font-size: 12px;
        }
        &.disable {
            color: $disable;
            border-color: $disable;
            & > .icon {
                color: $disable;
            }
            &:active {
                color: $disable;
                border-color: $disable;
                background-color: $back-color;
            }
        }
    }
}
.child-list {
    position: absolute;
    padding: 5px 0;
    top: 35px;
    left: 0px;
    width: 152px;
    background: $base-color;
    box-shadow: 0px 1px 7px -2px rgba(13, 36, 60, 1);
    border-radius: 0px 4px 4px 4px;
    z-index: 100;
    & > li,
    .case-list > li {
        list-style: none;
        // color: $light-purple;
        font-size: 14px;
        overflow: hidden;
        padding-left: 10px;
        &:first-child {
            border-bottom: 1px solid $border-color;
        }
        &.disabled {
            background-color: $base-color;
            a {
                color: $border-color;
            }
            &:hover {
                background-color: $base-color;
            }
        }
        &:hover {
            background-color: $back-color;
        }
        &:first-child a {
            display: inline-block;
            width: 132px;
        }
        a {
            color: $dark-purple;
            font-size: 14px;
            line-height: 30px;
            width: 90%;
            white-space: nowrap;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .case-list {
        max-height: 90px;
        overflow-y: scroll;
        & > li:first-child {
            border-bottom: none;
        }
    }
}

.spining {
    animation: spining 2s linear infinite;
}
@keyframes spining {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(-360deg);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/editPanel.vue